import React from 'react'
import BuildCircleIcon from '@mui/icons-material/BuildCircle'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

import AvatarItem from 'components/CarSettings/Common/Creation/Summary/AvatarItem'
import Skeleton from 'components/CarSettings/Common/Creation/Summary/Skeleton'
import TranslationItem from 'components/CarSettings/Common/Creation/Summary/TranslationItem'
import SummaryItem from 'components/Common/SummaryItem'

import { textFiles } from 'constants/textFiles'
import useTranslation from 'hooks/useTranslation'
import { CategoryCreationProps } from 'utils/CarSettings/Category/creation'

import { SectionContainer } from 'styles/creation'

const Summary = ({
  handleBack,
  categoryData,
  handleSubmit,
  submitLoading,
}: CategoryCreationProps) => {
  const { categoryInformation } = categoryData
  const { translations } = categoryInformation
  const { text: generalText } = useTranslation(textFiles.GENERAL)
  const { text } = useTranslation(textFiles.CATEGORY_CREATION)
  const { summary } = text

  return (
    <Skeleton
      previousFunction={handleBack}
      nextFunction={handleSubmit}
      title={summary.title}
      description={summary.description}
      submitLoading={submitLoading}
    >
      <SectionContainer>
        <SummaryItem
          title={summary.name}
          text={categoryInformation.name}
          icon={<BuildCircleIcon />}
        />
        <SummaryItem
          title={summary.status}
          text={generalText.status[categoryInformation.status]}
          icon={<CheckCircleIcon />}
        />
        {translations.length > 0 ? (
          <TranslationItem translations={categoryInformation.translations} />
        ) : null}
        <AvatarItem
          title={summary.logo}
          picture={categoryInformation.picture}
        />
      </SectionContainer>
    </Skeleton>
  )
}

export default Summary
